import axios from "axios";
import toastr from "toastr";
import store from "../store/index";
import exemptRoutes from "../misc/exempt-routes";
import * as _ from "lodash";

export default function setup() {
  //axios.create({
  //    baseURL: 'http://localhost:3000/api/v1',
  //    timeout: 5000,
  //    headers: {
  //        'X-Auth-Token': 'f2b6637ddf355a476918940289c0be016a4fe99e3b69c83d',
  //        'Content-Type': 'application/json'
  //    }
  //});

  var instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_URI,
    withCredentials: true,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      //"X-XSRF-TOKEN": getCookie("XSRF-TOKEN")
    },
  });

  instance.interceptors.request.use(
    function(config) {
      // Do something before request is sent
      config.headers["X-XSRF-TOKEN"] = store.state.auth.user.xsrftoken;
      _.forEach(exemptRoutes, function(route) {
        if (_.includes(config.url.toLowerCase(), route.path.toLowerCase()) && config.method === route.method) {
          console.log("exempt route: " + config.url.toLowerCase());
        } else {
          store.dispatch("spinner/addRequest");
        }
      });

      return config;
    },
    function(error) {
      // Do something with request error
      store.dispatch("spinner/removeRequest");
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    function(response) {
      // Do something with response data
      var exempt = false;
      _.forEach(exemptRoutes, function(route) {
        if (
          _.includes(
            response.config.url.toLowerCase(),
            route.path.toLowerCase()
          ) &&
          response.config.method === route.method
        ) {
          console.log("exempt route: " + response.config.url.toLowerCase());
          exempt = true;
        }
      });
      if (!exempt) store.dispatch("spinner/removeRequest");
      return response;
    },
    function(error) {
      store.dispatch("spinner/removeRequest");
      // Do something with response error
      console.log(error.response);

      toastr.options = {
        closeButton: true,
        debug: false,
        newestOnTop: false,
        progressBar: false,
        positionClass: "toast-top-right",
        preventDuplicates: false,
        onclick: null,
        showDuration: "300",
        hideDuration: "1000",
        timeOut: "0",
        extendedTimeOut: "1000",
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "fadeIn",
        hideMethod: "fadeOut",
      };

      // Toastr Message
      if (error.response) {
        if (error.response.status === 401) {
          window.location.href =
            process.env.VUE_APP_BASE_URI +
            "/home/login?returnUrl=" +
            window.location.href;
          return;
        } else if (error.response.status === 403) {
          window.location.href = "/not-authorized";
        } else if (error.response.status === 404) {
          window.location.href = "/404";
          return;
        } else if (error.response.data) {
          toastr.error(error.response.data);
        } else {
          toastr.error("Error " + error.response.status, error.message);
        }
      } else {
        toastr.error(error.message);
      }

      return Promise.reject(error);
    }
  );

  return instance;
}
